import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import * as yup from "yup";

// tailwind-merge needs to know about container-query variants (like `@md:*`)
// so it doesn't incorrectly dedupe/resolve them when classes are composed via `cn()`.
const twMerge = extendTailwindMerge<never, "container">({
  extend: {
    // Tailwind's container query plugin ships these by default.
    theme: {
      container: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        "2xl",
        "3xl",
        "4xl",
        "5xl",
        "6xl",
        "7xl",
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Checks if a field has `.required()` set for a field in a `yup` schema.
 *
 * @param schema - The yup schema to check
 * @param fieldName - The name of the field to check
 * @returns true if the field is required, false otherwise
 */
export const isRequired = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- lint-backlog: any is part of the current public type; narrowing it changes the API
  schema: yup.ObjectSchema<any>,
  fieldName: string,
) => {
  const fieldDescription = schema.fields[fieldName].describe(
    {},
  ) as yup.SchemaDescription;

  return !fieldDescription.optional;
};
